<template>
  <div class="image-container">
    <img src="../../../assets/mirror_imgs/merge.png"
         @click="mergeImage" />
  </div>
</template>

<script setup lang="ts">
import { useMirrorStore } from '../../../index'
import { mergeProduct, queryTask, uploadDiffusion } from '&/plugins/home/api/mirrorSpace'
import { message } from 'ant-design-vue'
import { useI18n } from "vue-i18n"

const { t } = useI18n()
const mirrorStore = useMirrorStore()

const mergeImage = async () => {
  if (!mirrorStore.previewClothing) {
    message.error(t('home.Merge.error1'))
    return
  } else if (!mirrorStore.previewModel) {
    message.error(t('home.Merge.error2'))
    return
  }


  try {
    mirrorStore.mergePreviewState = true
    if (typeof mirrorStore.previewClothing !== 'string') {
      convertImages().then(async result => {
        await uploadDiffusion('clothing', result as string)
      })
    } else {
      await uploadDiffusion('clothing', mirrorStore.previewClothing)
    }
    await uploadDiffusion('model', mirrorStore.previewModel)

    const resultTask = await mergeProduct()
    const resultData = await queryTaskUntilSuccess(resultTask.taskId)
    mirrorStore.mergePreviewState = false
    if (resultData) {
      mirrorStore.mergePreview = resultData
      mirrorStore.mergePreviewArray.push(resultData)
    } else {
      message.error(t('home.Merge.error3'))
    }

  } catch (err) {
    mirrorStore.mergePreviewState = false
    message.error(t('home.Merge.error3'))
  }
}

async function convertImages(): Promise<string | null> {
  if (mirrorStore.productFabric.isCustomized()) {
    const exportImage = await mirrorStore.productFabric.exportFullImageAsBlob()

    const result = await convertToDataUrl(exportImage)
    return result

  } else {
    return null // 如果未定制，返回 null 或适当的默认值
  }
}

async function queryTaskUntilSuccess(taskId: string, maxRetries: number = 20, interval: number = 3000): Promise<any> {

  for (let i = 0; i < maxRetries; i++) {
    try {
      const response = await queryTask(taskId)
      if (response.result && response.status === 'completed') {
        return response.result
      } else if (response.result === false && response.status === 'completed') {
        return false
      }

    } catch (error) {
      console.error(`${t('home.Merge.error4')}:`, error)
    }

    // 等待一段时间再重试
    await new Promise(resolve => setTimeout(resolve, interval))
  }

  throw new Error(t('home.Merge.error5'))
}

async function convertToDataUrl(imageFile: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = function (event: any) {
      const result = event.target.result
      resolve(result)
    }

    reader.onerror = function (error) {
      reject(error)
    }

    reader.readAsDataURL(imageFile)
  })
}
</script>

<style scoped lang="less">
.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%; // 可根据需要调整高度
}

img {
  cursor: pointer;
  width: 320px;
  height: 181px;
}
</style>
